import { TURN_MODE_VTL, turnModeVtl, TURNING_DIRECTION_VTL, turningDirectionVtl } from '@/plugins/dictionary'

const state = {
    cycleItemAfter: 21,
    cycles: 1,
    default_routeForm: {
        airLineCode: 1, // 航线编号
        airLineHigh: 15, // 航线高度
        airLineSpeed: 5, // 航线速度
        verticalSpeed: 1, // 航线垂直速度
        turnMode: 0, // 转弯模式 0:定点,1:协调
        safeR: 5, // 安全半径
        delayTime: 3, // 悬停时间
        airLineEndMode: 21, // 最后一点的航点模式
        // airLineChange: 1, // 航线切入点
        airLineLength: 0, // 航线长度
        airLineFlightTime: 0, // 预计飞行时间
        cycleItemAfter: 21,// 完成动作
        cycles: 1, // 循环次数
        cycleTime: 1, // 循环次数
        altType: 0, // 0:相对高度,1:海拔高度
        show: true
    },
    default_routeForm_vtl: {
        airLineCode: 1, // 航线编号
        airLineHigh: 50, // 航线高度
        airLineSpeed: 25, // 航线速度
        verticalSpeed: 1, // 航线垂直速度
        turnMode: 0, // 转弯模式
        safeR: 150, // 安全半径
        delayTime: 3, // 悬停时间
        airLineEndMode: 21, // 最后一点的航点模式
        // airLineChange: 1, // 航线切入点
        airLineLength: 0, // 航线长度
        airLineFlightTime: 0, // 预计飞行时间
        cycleItemAfter: 21,// 完成动作
        cycles: 1, // 循环次数
        cycleTime: 1, // 循环次数
        altType: 0, // 0:相对高度,1:海拔高度
        show: true
    },
    default_routeSpotForm: {
        longitude: 0,
        latitude: 0,
        altitude: 15,
        speed: 5,
        verticalSpeed: 1,
        accMax: 2,
        safeR: 5,
        turnMode: 1,
        itemMode: 4,
        brng: 0,
        angle: 0,
        dist: 0,
        // wayponitSort:0,
        dalyTime: 3,
        params: "0,0,0,0",
        deviceNumber: 0,
        deviceIndex: 0,
        action: 0,
        actions: [],
        value: 0,
        yawMode: 0, // 机头指向
        targetPointLng: undefined, // 目标点经度
        targetPointLat: undefined, // 目标点纬度
        yaw: 0, // 航向锁定角度
    },
    default_routeSpotForm_vtl: {
        longitude: 0,
        latitude: 0,
        altitude: 50,
        speed: 25,
        verticalSpeed: 1,
        accMax: 2,
        safeR: 150,
        turnMode: TURN_MODE_VTL.ARRIVE, // 到达点
        itemMode: 5,
        direction: TURNING_DIRECTION_VTL.CLOCKWISE, // 转弯方向
        brng: 0,
        angle: 0,
        dist: 0,
        // wayponitSort:0,
        dalyTime: 3,
        params: "0,0,0,0",
        deviceNumber: 0,
        deviceIndex: 0,
        action: 0,
        actions: [],
        value: 0,
        yawMode: 0, // 机头指向
        targetPointLng: undefined, // 目标点经度
        targetPointLat: undefined, // 目标点纬度
        yaw: 0, // 航向锁定角度
    },
    routes: [],
    routeListVisible: false,// 打开航线列表
    openRouteTemplate: false,// 打开航线模板
    openAltChart: false,// 打开高程图表
    selectRouteNum: undefined,// 当前选中的航线编号
    altData: {
        min: 0,
        max: 0,
        data: []
    },
    homeWaypoint: undefined, // 归航点数据
}

const mutations = {
    setState(state, payload) {
        state[payload.key] = payload.value
    },
    setAltData(state, payload = []) {
        let min = 0
        let max = 0
        let alts = []
        if (payload.length > 0) {
            alts = payload.map(({ altitude }) => {
                return altitude
            })
            min = Math.min(...alts)
            max = Math.max(...alts)
        }
        state.altData = {
            min,
            max,
            data: alts
        }
    },
}

const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
